import React, { Component } from 'react'
import axios from 'axios';
import {BrowserRouter, NavLink, Route ,Switch} from 'react-router-dom';
import {App} from './App';
import { withRouter } from "react-router";
import {Table} from 'react-bootstrap';
import {Button,ButtonToolbar} from 'react-bootstrap';
import {AddTasksModal} from './AddTasksModal';
import {EditTasksModal} from './EditTasksModal';
import Multiselect from 'multiselect-react-dropdown';
import queryString from 'query-string';
class AdminTasks extends Component {
  constructor (props){
    super(props);
    this.filterClickTest.bind(this);
    this.state = {
      TopicList:[],
      DomainList:[],
      TaskList:[],
      techlist:[],
      levellist:[],
      options: [],
      HeaderList:[],
      servicegroup:"",
        addModalShow:false,
        editModalShow:false,
        username:""
    }     

}


componentDidMount() {
  this.handleQueryString();
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTask/Get/"+"1"+";"+"2").then(response => response.json())
  .then(res=> {            
    this.setState ( { TaskList: res} )
      })
      .catch(err => {
        console.log(err);
    }) 
    console.log(this.state.TaskList);

    fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTask/GetTasksHeader/"+"1"+";"+"2").then(response => response.json())
    .then(res=> {            
      this.setState ( { HeaderList: res} )
        })
        .catch(err => {
          console.log(err);
      }) 
      console.log(this.state.HeaderList);
      document.title ="KTPlanConfigurator";
}

componentDidUpdate(){

}

getlevel() {
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/LevelList/"+this.state.servicegroup).then(response => response.json())
  .then(res=> {            
    this.setState ( { levellist: res } )
      })
      .catch(err => {
        console.log(err);
    }) 

    

}
handleQueryString = () => {
  let queries = queryString.parse(window.location.search)
  if(queries.username !=undefined)
  {
    this.state.username = queries.username;
  }
}
getdomain() {
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTopic/Domains").then(response => response.json())
  .then(res=> {            
    this.setState ( { DomainList: res } )
      })
      .catch(err => {
        console.log(err);
    }) 
}
TasksHeaderClick() {

  this.props.history.push({

    pathname: '/AdminTaskHeader',
    search:"?username="+this.state.username,
  })  
}
onSelect(selectedList, selectedItem) {
  this.state.test ="";
 for(let i=0;i<selectedList.length;i++)
 {
   this.state.test += ","+selectedList[i].value;
 }
 if(this.state.test.toString().includes("1") && this.state.test.toString().length<=2)
 {

 
  this.state.level = "";
 }
 else
 {
  
  this.state.level = "2";
 }
 console.log(this.state.test);
}



onRemove(selectedList, removedItem) {

  this.state.test ="";
  for(let i=0;i<selectedList.length;i++)
  {
    this.state.test += ","+selectedList[i].value;
  }
  if(this.state.test.toString().includes("1") && this.state.test.toString().length<=2)
 {
 
  this.state.level = "";
 }
 else if(this.state.test.toString().includes("2") || this.state.test.toString().includes("3"))
 {
 
  this.state.level = "2";
 }
 else
 {
  
  this.state.level = "";
 }
  console.log(this.state.test);
}




Domainchange(e) {
  this.state.App = e.target.value;
  document.getElementById('ddlTech').disabled = false;
  axios.get("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/TechnologyListIO/"+e.target.value)
  .then(res=> {            
    this.setState ( { techlist: res.data } )
      })
      .catch(err => {
        console.log(err);
    }) 
}


getscope() {
  fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/Index/ScopeList/"+"AO").then(response => response.json())
  .then(res=> {            
    this.setState ( {options:res } )
      })
      .catch(err => {
        console.log(err);
    }) 
}

Levelchange(e) {

  this.state.level = e.target.value;

}
SGChange(e) {
  if(e.target.value != "Select" && e.target.value == "AO")
  {
  this.state.servicegroup = e.target.value;
  
  this.getlevel();
  this.getscope();
  document.getElementById('divAO').style.display = 'block'
  document.getElementById('divIE').style.display = 'none'
  }

if(e.target.value != "Select" && e.target.value == "IE")
  {
  this.state.servicegroup = e.target.value;
  this.getdomain();
  document.getElementById('divIE').style.display = 'block'
  document.getElementById('divAO').style.display = 'none'
  }
}
TopicClick() {

  this.props.history.push({

    pathname: '/AdminTopics',
    search:"?username="+this.state.username,
    
  })  
}
TechClick() {

  this.props.history.push({

    pathname: '/AdminTechnology',
    search:"?username="+this.state.username,
    
  })  
}
TopicTechdefaultClick() {

  this.props.history.push({

    pathname: '/AdmindefaultTopicTechMapping',
    search:"?username="+this.state.username,
  })  
}
TopicTechClick() {

  this.props.history.push({

    pathname: '/AdminTopicTechMapping',
    search:"?username="+this.state.username,
    
  })  
}

filterClickTest = (a,b,c) => {
  this.setState ( { servicegroup: a,test:b,level:c,tech:b} );
  
  if(this.state.servicegroup == "AO")
    {
    fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTask/Get/"+this.state.test+";"+(this.state.level.toString()==""?3:this.state.level)).then(response => response.json())
    .then(res=> {            
      this.setState ( { TaskList: res} )
        })
        .catch(err => {
          console.log(err);
      }) 
      console.log(this.state.TaskList);
      
      fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTask/GetTasksHeader/"+this.state.test+";"+(this.state.level.toString()==""?3:this.state.level)).then(response => response.json())
      .then(res=> {            
        this.setState ( { HeaderList: res} )
          })
          .catch(err => {
            console.log(err);
        }) 
        console.log(this.state.HeaderList);

      
    }
    if(this.state.servicegroup =="IE")
    {
      fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTask/GetIO/"+this.state.tech+";"+"3").then(response => response.json())
      .then(res=> {            
        this.setState ( { TaskList: res} )
          })
          .catch(err => {
            console.log(err);
        }) 
        console.log(this.state.TaskList);


        fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTask/GetTasksHeaderIO/"+this.state.tech+";"+"3").then(response => response.json())
        .then(res=> {            
          this.setState ( { HeaderList: res} )
            })
            .catch(err => {
              console.log(err);
          }) 
          console.log(this.state.HeaderList);
       
    }
    this.state.editModalShow= false ;
    this.state.addModalShow = false;
}

adminClick(){

  this.props.history.push({

    pathname: '/',
    
    state: {  username:this.state.username},
    search:"?username="+this.state.username,
   
})
}

  filterClick() {
    document.getElementById('divTable').style.display = 'block';
    if(this.state.servicegroup == "AO")
    {
    fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTask/Get/"+this.state.test+";"+(this.state.level.toString()==""?3:this.state.level)).then(response => response.json())
    .then(res=> {            
      this.setState ( { TaskList: res} )
        })
        .catch(err => {
          console.log(err);
      }) 
      console.log(this.state.TaskList);
      
      fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTask/GetTasksHeader/"+this.state.test+";"+(this.state.level.toString()==""?3:this.state.level)).then(response => response.json())
      .then(res=> {            
        this.setState ( { HeaderList: res} )
          })
          .catch(err => {
            console.log(err);
        }) 
        console.log(this.state.HeaderList);

      
    }
    if(this.state.servicegroup =="IE")
    {
      fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTask/GetIO/"+this.state.tech+";"+"3").then(response => response.json())
      .then(res=> {            
        this.setState ( { TaskList: res} )
          })
          .catch(err => {
            console.log(err);
        }) 
        console.log(this.state.TaskList);


        fetch("https://as-mobilization.accenture.com/KTPlanConfig/api/AdminTask/GetTasksHeaderIO/"+this.state.tech+";"+"3").then(response => response.json())
        .then(res=> {            
          this.setState ( { HeaderList: res} )
            })
            .catch(err => {
              console.log(err);
          }) 
          console.log(this.state.HeaderList);
       
    }

     
  }


render() {
  const {TaskId,TaskName,username,HeaderList,scope,level,servicegroup,taskheaderid,mandatory,unique,filterchange,filterchangetest,TaskList} = this.state;
    let addModalClose=()=>this.setState({addModalShow:false});
    let editModalClose=()=>this.setState({editModalShow:false});
    return (
        <div class="bg-background" style={{background:'#F2F2F2'}}>
        <div class="row">
            <div class="container-fluid">
            <div class="header-content" style={{marginLeft:17}}>
              <img src="images/Capture.png" style={{paddingBottom:5}} alt="Accenture Technology" class="img-icon" />
              <span class="new-KT-navbar" style={{marginLeft:5}}>KT Plan Configurator</span>
              <button type='button' style={{marginLeft:850,marginTop:5}}  className='btn-new btn-confirm' onClick={() => this.adminClick()}>KT Plan</button>

          </div>
              <div class="demographic-form margin-top15 border-main-div new-KT" style={{height:500,overflow:'auto'}} >
              <div class="ul-financials margin-bottom15">
              <a class="active" style={{marginRight:50,color:'black',fontWeight:'bold'}} onClick={() => this.TechClick()}>Technology</a>
              <a  Text="Header" style={{marginRight:50,color:'black',fontWeight:'bold'}}  onClick={() => this.TasksHeaderClick()} ID="lnkTasksHeaders" >Tasks Header Maintenance</a>
              <a  Text="Tasks" style={{marginRight:50,color:'black',fontWeight:'bold',borderBottom:2,borderBottomColor:'#7500c0',borderBottom:'solid',paddingBottom:5}}  ID="lnkTasks" >Tasks Maintenance</a>
                <a Text="Topic" style={{marginRight:50,color:'black',fontWeight:'bold'}} onClick={() => this.TopicClick()} ID="lnkTopic" >Topic Maintenance</a>
                <a  Text="Topic Technology" style={{marginRight:50,color:'black',fontWeight:'bold'}} onClick={() => this.TopicTechClick()} >Topic-Technology Mapping</a>
                <a  Text="Topic Technology default" style={{marginRight:50,color:'black',fontWeight:'bold'}} onClick={() => this.TopicTechdefaultClick()} >Default Technology</a>

            </div>
              <div class="col-md-12 ">

<div class="col-md-4" >
      <label for=" " class="control-label margin-bottom5  margin-top5" >Service Group *</label>
      <select style={{width:275,height:37}} id='ddlSG' onChange={(e) => this.SGChange(e)} name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance"  class="aspNetDisabled form-control input-sm   textarea-style watermark">
      <option value="Select">Select</option>
      <option value="AO">AMS</option>
      <option value="IE">IMS</option>
     
      </select>
     
    </div>
    <div id='divAO' style={{display:'block'}}>
    <div class="col-md-4" id='mlScope'>
         <label for=" " class="control-label margin-bottom5  margin-top5" >What is the scope of support for this application? *</label>
       
         <Multiselect
         
         options={this.state.options} 
         selectedValues={this.state.selectedValue} 
         onSelect={this.onSelect.bind(this)} 
         onRemove={this.onRemove.bind(this)}
         avoidHighlightFirstOption={true}
         displayValue="text" 
         ref={this.multiselectRef2}
         />
       
        </div>

        <div class="col-md-4">
         <label for=" " class="control-label margin-bottom5  margin-top5" >What is the level of support? *</label>
         <select style={{width:275,height:36}} onChange={(e) => this.Levelchange(e)}  name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance"  id='ddlLevel' class="aspNetDisabled form-control input-sm   textarea-style  margin-bottom5 watermark">
         <option>Select</option>
          {
              
              this.state.levellist.map(list =>
                   <option value={list.value}>{list.text}</option>)
           }
         </select>
        
       </div>
       </div>
       <div  id='divIE'  style={{display:'none'}}>
       <div class="col-md-4">
         <label for=" " class="control-label margin-bottom5  margin-top5" >What is the Domain? *</label>
         <select  style={{height:38}} onChange={(e) => this.Domainchange(e)} name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance"  id='ddlDomain' class=" form-control input-sm   textarea-style  margin-bottom5 watermark">
                   <option value='Select'>Select</option>
                  
                   {
                        
                        this.state.DomainList.map(list =>
                             <option value={list.value} >{list.text}</option>)
                     }

                   </select>
        
       </div>
       <div class="col-md-4">
         <label for=" " class="control-label margin-bottom5  margin-top5" >What is the Tower? *</label>
         <select style={{width:275,height:38,display:'block',disabled:true}}  onChange={(e) => this.setState({tech: e.target.value,techname:e.target.options[e.target.selectedIndex].text})} name="ctl00$ContentPlaceHolder1$ddlIncludeGovernance" id='ddlTech' class="aspNetDisabled form-control input-sm   textarea-style  margin-bottom5 watermark">
                      <option>Select</option>
                      {
                           
                           this.state.techlist.map(list =>
                                <option value={list.value} key={list.text} >{list.text}</option>)
                        }

                      </select>
        
       </div>
       </div>

         <button type='button' onClick={() => this.filterClick()}  className='btn-new'  >Filter</button>

</div>
             
             <div id='divTable' style={{display:'none'}}>
              <div class="col-md-12 " style={{marginTop:5}} >
                      <button type='button'  className='btn-new' onClick={()=>this.setState({addModalShow:true})} style={{marginBottom:5}} >New Task</button>
                   
                     
                    </div>
                 <Table className='mt-4' striped bordered hover size='sm'>
                   <thead style={{background:'#e6dcff'}}>
                       <tr>
                       <th>Task Id</th>
                       <th>Task Header</th>
                       <th>Task Name</th>
                       <th>Unique Identifier</th>
                       <th>support Level</th>
                       <th>Mandatory</th>
                       <th></th>
                       </tr>
                   </thead>
                   <tbody>
                       {
                       this.state.TaskList.map(obj=>
                       <tr key={obj.taskid}>
                            <td>{obj.taskid}</td>
                            <td>{obj.taskHeader}</td>
                            <td>{obj.taskName}</td>
                            <td>{obj.uniqueIdentifier}</td>
                            <td>{obj.supportLevel}</td>
                            <td>{obj.mandatory==1?"Yes":"No"}</td>
                            <td>
                              <ButtonToolbar>
                                <img src="images/edit-new.png" className='mr-2' variant='info' onClick={()=>this.setState({editModalShow:true,
                                TaskName:obj.taskName,TaskId:obj.taskid,taskheaderid:obj.taskheaderid,
                                mandatory:obj.mandatory,unique:obj.uniqueIdentifier})} />
                               
                               
                              </ButtonToolbar>
                            </td>
                       </tr>
                       )}
                   </tbody>
                 </Table>
                 </div>
                  </div>
                  </div>
                  </div>
                  <ButtonToolbar>
                    <AddTasksModal show={this.state.addModalShow} 
                    HeaderList = {this.state.HeaderList}
                    scope = {this.state.servicegroup == "AO"?this.state.test:this.state.tech}
                    level = {this.state.servicegroup == "AO"?this.state.level:"3"}
                    servicegroup = {this.state.servicegroup}
                    filterchangetest = {this.filterClickTest}
                    username = {this.state.username}
                     onHide={addModalClose}/>

                    <EditTasksModal show={this.state.editModalShow}
                               onHide={editModalClose}
                               TaskName={TaskName}
                               TaskId={TaskId}
                               taskheaderid={taskheaderid}
                               mandatory={mandatory}
                               unique={unique}
                               HeaderList = {this.state.HeaderList}
                               scope = {this.state.servicegroup == "AO"?this.state.test:this.state.tech}
                               level = {this.state.servicegroup == "AO"?this.state.level:"3"}
                               servicegroup = {this.state.servicegroup}
                               filterchangetest = {this.filterClickTest}
                               username = {this.state.username}
                               ></EditTasksModal>
                                
                  </ButtonToolbar>
                  </div>
    )
}
}
export default withRouter(AdminTasks);
